import React, { forwardRef } from 'react';

import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import useKeyboard from '@/modules/corporate/modules/database/fields/hooks/useKeyboard';
import { CellProps } from '@/modules/corporate/modules/database/types';

const Number = forwardRef<HTMLDivElement, CellProps>((props: CellProps, ref) => {
  const { cellData, toggleIsEditing, rowIndex, columnIndex, className } = props;

  const { onKeyDown } = useKeyboard({ onEnterPress: toggleIsEditing });

  return (
    <Stack
      ref={ref}
      className={cn('h-full w-full py-8 ps-6 pe-12', className)}
      data-colindex={columnIndex}
      data-rowindex={rowIndex}
      tabIndex={0}
      onClick={toggleIsEditing}
      onKeyDown={onKeyDown}>
      <Typography className="w-full text-end" color="text-text-paragraph" variant="body-short-02">
        {cellData?.value}
      </Typography>
    </Stack>
  );
});

export default Number;
